  export const StepIndicator = ({ steps, currentStep }) => {
    return (
      <div className="flex items-center justify-center mb-8 -space-x-10">
        {steps.map((s, index) => {
          const isActive = s.id === currentStep
          const isCompleted = s.id < currentStep
          const isLast = index === steps.length - 1

          return (
            <div key={s.id}>
              <div className="flex items-center gap-2">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold ${
                    isActive
                      ? "bg-[#572575] text-white"
                      : isCompleted
                        ? "bg-[#572575] text-white"
                        : "bg-gray-300 text-gray-600"
                  }`}
                >
                  {s.id}
                </div>
                <div
                  className={`font-siromi text-[20px] leading-none tracking-[0] text-center ${
                    isActive ? "text-gray-900" : "text-gray-600"
                  }`}
                >
                  {s.title}
                </div>
              </div>
              <div className="ml-10 flex items-center">
                <div
                  className={`font-altis text-[16px] tracking-[0] px-2 py-1 rounded-lg text-sm font-medium inline-block mt-1 ${
                    isActive
                      ? "bg-[#FEF6FE] text-[#BF5BB0] border border-[#DDBBDD]"
                      : isCompleted
                        ? "bg-green-100 text-green-600"
                        : "bg-gray-100 text-gray-500 border border-gray-300"
                  }`}
                >
                  {isActive ? "In Progress" : isCompleted ? "Completed" : "Pending"}
                </div>
                {!isLast && <div className="w-[250px] ml-2 z-50 h-[2px] bg-gray-400"></div>}
              </div>
            </div>
          )
        })}
      </div>
    )
  }
